import React from "react";
import { createUseStyles, useTheme } from "react-jss";
import clsx from "clsx";
import useMediaQuery from "../../hooks/useMediaQuery";
var useStyles = createUseStyles({
    svg: {
        width: function (_a) {
            var isLarge = _a.isLarge;
            return isLarge ? 24 : 18;
        },
        height: function (_a) {
            var isLarge = _a.isLarge;
            return isLarge ? 25 : 19;
        },
        flexShrink: 0,
        userSelect: "none",
        fill: "none",
        stroke: function (props) { return props.color; },
        strokeLinecap: "round",
        strokeLinejoin: "round",
    }
});
export default function DoubleArrowIcon(_a) {
    var _b = _a.color, color = _b === void 0 ? "white" : _b, className = _a.className;
    var theme = useTheme();
    var isLarge = useMediaQuery(theme.breakpoints.up("lg"));
    var classes = useStyles({ color: color, isLarge: isLarge });
    return (React.createElement("svg", { viewBox: "0 0 23.74 24.64", className: clsx(classes.svg, className) },
        React.createElement("polyline", { className: "st0", points: "3.79,11.85 11.73,20.13 19.95,11.89 ", style: { strokeWidth: 4 } }),
        React.createElement("polyline", { className: "st1", points: "3.79,6.07 11.73,14.35 19.95,6.11 " })));
}
//# sourceMappingURL=DoubleArrowIcon.js.map